<template>
  <div class="product-item" @click="productClicked">
    <div
      class="product-inner"
      :class="{ 'buider-mode': builderMode, hidden: hidden }"
    >
      <div class="product-image" :style="backgroundImage"></div>
      <div class="product-name text-truncate">
        {{ wardrobeProduct.product.brand_name }}
      </div>
    </div>

    <div class="product-actions" v-if="!builderMode">
      <AddRemoveWardrobeDropdown
        :productId="product.id"
        :wardrobeId="wardrobeProduct.wardrobe_id"
        :similar="wardrobeProduct.similar"
        :group="wardrobeProduct.group"
      />
    </div>
  </div>
</template>

<script>
import AddRemoveWardrobeDropdown from "@/components/wardrobe/AddRemoveWardrobeDropdown";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AddRemoveWardrobeDropdown
  },

  props: {
    wardrobeProduct: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      builderOutfit: "builderOutfit",
      builderMode: "wardrobeBuilderMode"
    }),

    product() {
      return this.wardrobeProduct.product;
    },

    backgroundImage() {
      return 'background-image: url("' + this.product.featured_image + '")';
    },

    hidden() {
      return !(
        !this.builderMode ||
        (this.builderMode && this.hasEmptyOutfitSlot) ||
        (this.builderMode && this.inOutfitSlot)
      );
    },

    hasEmptyOutfitSlot() {
      let entry = this.builderOutfit.find(
        el => el.layerSlug.includes(this.wardrobeProduct.group) && !el.product
      );
      return !!entry;
    },

    inOutfitSlot() {
      let entry = this.builderOutfit.find(
        el =>
          el.layerSlug.includes(this.wardrobeProduct.group) &&
          el.product &&
          el.product.id === this.product.id
      );
      return !!entry;
    }
  },

  methods: {
    ...mapActions([
      "addProductToBuilderOutfit",
      "removeProductFromBuilderOutfit"
    ]),

    productClicked() {
      if (this.builderMode) {
        this.inOutfitSlot
          ? this.removeProductFromBuilderOutfit(this.wardrobeProduct)
          : this.addProductToBuilderOutfit(this.wardrobeProduct);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_product-item.scss";
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/clothes/Product.vue